import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    filterKey: String, 
    filterLabel: String,
    showAppliedFilterLabel: { type: Boolean, default: true }
  }

  connect() {
    this.element.addEventListener("change", this.filterChanged.bind(this))
    this.element.addEventListener("filter:clear", this.clearFilter.bind(this))
  }

  filterChanged() {
    const event = new CustomEvent("filter:change", {
      detail: {
        label: this.filterLabelValue,
        value: this.element.checked,
        filterKey: this.filterKeyValue,
        showAppliedFilterLabel: this.showAppliedFilterLabelValue
      }
    })

    this.element.dispatchEvent(event)
  }

  clearFilter() {
    this.element.checked = false
    this.element.dispatchEvent(new Event("change"))
  }
}
